import { MODALS_COMMON_MUTATION_SET_OPEN } from '@/store/modules/modals/common/modalCommon.constant'

export default {
  [MODALS_COMMON_MUTATION_SET_OPEN]: (state, toggle) => {
    state.open = toggle
  }
}
